import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "return-gift-btn"
}

import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router'
import { useWindowSize, useRect } from '@vant/use';
import { queryRecall } from '@/api';


export default {
  __name: 'ReturnGiftBtn',
  setup(__props) {

const { width, height } = useWindowSize();
const router = useRouter()

const dragRef = ref(null);
const sn = ref('');
const positionStyle = ref('right: 0px; bottom: 120px;');
const coordinate = reactive({
  client: {},
  elePosition: {},
});

onMounted(() => {
  fetchRecall();
});

const fetchRecall = () => {
  queryRecall().then(res => {
    const { activitySn } = res.data || {};
    sn.value = activitySn;
  })
}

const clickIcon = () => {
  router.push({ name: 'returnGift', params: { sn: sn.value } });
};

const touchstartHandle = (refName, e, flag) => {
  if (!flag) {
    return false;
  };
  let element = e.targetTouches[0];
  
  // 记录点击的坐标
  coordinate.client = {
    x: element.clientX,
    y: element.clientY
  };
  // 记录需要移动的元素坐标
  coordinate.elePosition.left = dragRef.value.offsetLeft;
  coordinate.elePosition.top = dragRef.value.offsetTop;
};

const touchmoveHandle = (refName, e, flag) => {
  if (!flag) {
    return false;
  };
  let element = e.targetTouches[0];
  // 根据初始 client 位置计算移动距离(元素移动位置=元素初始位置+光标移动后的位置-光标点击时的初始位置)
  let x = coordinate.elePosition.left + (element.clientX - coordinate.client.x);
  let y = coordinate.elePosition.top + (element.clientY - coordinate.client.y);
  // 限制可移动距离，不超出可视区域
  let leftLimit = 0;
  let rightLimit = innerWidth - dragRef.value.offsetWidth;
  let bottomLimit = innerHeight - dragRef.value.offsetHeight;
  x = x <= leftLimit ? leftLimit : x >= rightLimit ? rightLimit : x;
  y = y <= 0 ? 0 : y >= bottomLimit ? bottomLimit : y;
  // 移动当前元素
  dragRef.value.style.left = x + 'px';
  dragRef.value.style.top = y + 'px';
};

const touchendHandle = (refName, e, flag) => {
  if (!flag) {
    return false;
  };
  let ringRect = useRect(dragRef);
  // console.log(ringRect);
  let distanceX = ringRect.x + ringRect.width / 2, distanceY = ringRect.y + ringRect.height / 2;
  let position = 'right';
  // let positionX = 'left', positionY = 'top', position;
  // if(distanceX > width / 2) {
  //   distanceX = width - distanceX;
  //   positionX = 'right';
  // }
  // if(distanceY > height / 2) {
  //   distanceY = height - distanceY;
  //   positionY = 'bottom'
  // }
  // if (distanceY < distanceX) {
  //   position = positionY;
  // } else {
  //   position = positionX;
  // }
  // console.log('distanceX:', distanceX);
  // console.log('distanceY:', distanceY);
  // console.log(position);
  let x = ringRect.x;
  let y = ringRect.y;
  switch (position){
    case 'top':
      positionStyle.value = `top: ${0}px; left: ${x}px;`;
      break;
    case 'bottom':
      positionStyle.value = `bottom: ${0}px; left: ${x}px;`;
      break;
    case 'right':
      positionStyle.value = `right: ${0}px; top: ${y}px;`;
      break;
    default:
      positionStyle.value = `left: ${0}px; top: ${y}px;`;
      break;
  }
  // 判断拖动距离 小于5像素 触发click事件
  if (Math.abs(x - coordinate.elePosition.left) < 5 
    && Math.abs(y - coordinate.elePosition.top) < 5) {
    clickIcon();
  }
}

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _directive_audio = _resolveDirective("audio")

  return (sn.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "menu-center-wrap flex justify-center",
          style: _normalizeStyle(positionStyle.value),
          ref_key: "dragRef",
          ref: dragRef,
          onTouchstart: _cache[0] || (_cache[0] = _withModifiers($event => (touchstartHandle('dragSuspendIcon',$event, true)), ["stop"])),
          onTouchmove: _cache[1] || (_cache[1] = _withModifiers($event => (touchmoveHandle('dragSuspendIcon',$event, true)), ["stop","prevent"])),
          onTouchend: _cache[2] || (_cache[2] = _withModifiers($event => (touchendHandle('dragSuspendIcon',$event, true)), ["stop","prevent"])),
          onClick: clickIcon
        }, [
          _createVNode(_component_van_image, {
            class: "center-img",
            src: require('@/assets/img/return-gift/chest.gif')
          }, null, 8, ["src"])
        ], 36)), [
          [_directive_audio]
        ])
      ]))
    : _createCommentVNode("", true)
}
}

}